import React from "react";
import { Box, Chip, Link, Stack, TableCell, TableRow, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/DeleteForever";
import DriveFileMoveOutlinedIcon from "@mui/icons-material/DriveFileMoveOutlined";
import IconButtonIcons from "../../Common/IconButtonIcons";
import TableCommon from "../../Common/Table";
import { setSnackBar } from "../../../store/common/commonSlice";
import { useDispatch } from "react-redux";
import { handleDateTimeDefault } from "../../../helpers/utils";
import { useDeleteGalleryMutation } from "../../../store/masters/mastersApis";
import { PERMISSIONS } from "../../../helpers/constants";
import HasPermission from "../../Common/HasPermission";

const VideoGalleryTableComponent = ({
    loading,
    count,
    data,
    pagination,
    handlePagination,
    fetching = false,
    onAssignFolder,
}) => {
    const dispatch = useDispatch();
    const [handleDelete] = useDeleteGalleryMutation();

    const columns = [
        {
            title: "Sr. No.",
            sort: false,
        },
        {
            title: "Preview",
            sort: false,
        },
        {
            title: "Folder",
            sort: false,
        },
        {
            title: "Created At",
            field: "createdAt",
            sort: true,
        },
        {
            title: "Action",
            sort: false,
        },
    ];

    const deleteManage = async (_id) => {
        try {
            if (!window.confirm("Are you sure you want to delete?")) {
                return;
            }

            const response = await handleDelete({ _id });
            if (response?.error) {
                throw new Error(response?.error?.message);
            }

            dispatch(
                setSnackBar({
                    open: true,
                    message: "Deleted successfully",
                    severity: "success",
                }),
            );
        } catch (error) {
            dispatch(
                setSnackBar({
                    open: true,
                    message: error?.data?.message || error.message,
                    severity: "error",
                }),
            );
        }
    };

    const renderTableData =
        !loading && data && data.length > 0 ? (
            data.map((row, index) => (
                <TableRow
                    key={row?._id || index}
                    sx={{ "td, th": { borderBottom: 1, borderBottomColor: "divider", padding: "10px" } }}
                >
                    <TableCell align="center">{index + 1 + pagination.pageNo * pagination.limit}</TableCell>
                    <TableCell align="left">
                        <Stack direction="row" spacing={1.5} alignItems="center">
                            {row?.video_thumbnail ? (
                                <Box
                                    component="img"
                                    src={row.video_thumbnail}
                                    alt={row?.folder_data?.name || "Video thumbnail"}
                                    sx={{
                                        width: 72,
                                        height: 42,
                                        objectFit: "cover",
                                        borderRadius: 1.5,
                                        border: "1px solid",
                                        borderColor: "divider",
                                    }}
                                />
                            ) : null}
                            <Stack spacing={0.25}>
                                <Link href={row.url} target="_blank" rel="noreferrer" underline="hover">
                                    Open Video Link
                                </Link>
                                <Typography variant="caption" color="text.secondary">
                                    External video
                                </Typography>
                            </Stack>
                        </Stack>
                    </TableCell>
                    <TableCell align="center">
                        {row?.folder_data?.name ? (
                            <Chip
                                size="small"
                                color="primary"
                                variant="outlined"
                                label={row.folder_data.name}
                                sx={{ borderRadius: "8px" }}
                            />
                        ) : (
                            <Chip
                                size="small"
                                color="warning"
                                variant="outlined"
                                label="Unassigned"
                                sx={{ borderRadius: "8px" }}
                            />
                        )}
                    </TableCell>
                    <TableCell align="center">{handleDateTimeDefault(row?.createdAt)}</TableCell>
                    <TableCell align="center">
                        <HasPermission permission={PERMISSIONS.COMMON_MASTER.VIDEO_GALLERY.UPDATE} fallback={null}>
                            <IconButtonIcons
                                title={row?.folder_data?.name ? "Change Folder" : "Assign Folder"}
                                IconComponent={DriveFileMoveOutlinedIcon}
                                color="primary"
                                onClick={() => onAssignFolder(row)}
                            />
                        </HasPermission>
                        <HasPermission permission={PERMISSIONS.COMMON_MASTER.VIDEO_GALLERY.DELETE} fallback={null}>
                            <IconButtonIcons
                                title="Delete"
                                IconComponent={DeleteIcon}
                                color="error"
                                onClick={() => deleteManage(row._id)}
                            />
                        </HasPermission>
                    </TableCell>
                </TableRow>
            ))
        ) : (
            <TableRow sx={{ "td, th": { border: 0, padding: "10px" } }}>
                <TableCell colSpan={5} align="center">
                    Data not found
                </TableCell>
            </TableRow>
        );

    return (
        <TableCommon
            columns={columns}
            tableData={renderTableData}
            count={count}
            loading={loading || fetching}
            pagination={pagination}
            handlePagination={handlePagination}
        />
    );
};

export default VideoGalleryTableComponent;
